import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import axios from 'axios'
import useToken from '../App/useToken'
import { Access, hasAccess } from '../Helper/Helper'
import LoadingSpinner from '../Helper/LoadingSpinner'

export default function DownloadCSVPopup(props) {
  const [okToDownload, setOkToDownload] = useState(false)
  const [loading, setLoading] = useState(false)
  const [href, setHref] = useState(null)
  const [status, setStatus] = useState('Starting to fetch data')
  
  const {token, getCustomer} = useToken()
  const customer = getCustomer()
  
  const geojsonToCSV = (geojson) => {
    const features = geojson.features;
    if (!features || features.length === 0) {
        return "No data available";
    }

    const csvRows = [];

    // Step 1: Collect all distinct keys from feature.properties
    const allKeys = new Set();
    features.forEach(feature => {
        Object.keys(feature.properties || {}).forEach(key => allKeys.add(key));
    });

    // Convert Set to Array and maintain order
    let headers = [...allKeys];
    if(hasAccess(customer, Access.DOWNLOAD_GEOREFERENCED_DATA.number)){
      headers = [...allKeys, "geometry_coordinates"];
    
    } 


    csvRows.push(headers.join(";")); // Join headers with commas

    // Step 2: Extract data from each feature and ensure correct column alignment
    features.forEach(feature => {
        const row = headers.map(key => {
            if (key === "geometry_coordinates" && hasAccess(customer, Access.DOWNLOAD_GEOREFERENCED_DATA.number)) {
                return JSON.stringify(feature.geometry.coordinates); // Convert geometry to string
            }
            return feature.properties?.[key] ?? ""; // Use empty string for missing keys
        });
        csvRows.push(row.join(";")); // Join row values with commas
    });

    return csvRows.join("\n"); // Combine rows into CSV format
  };
  const tryRequire = ()  => {
    
    setOkToDownload(false)
    var formData = new FormData();
    formData.append('token', token);
    formData.append('AID', props.itemToDownload.AID);
    formData.append('timeFrame', props.ctx.selectedTimeFrame);
    formData.append('customerId', props.itemToDownload.customerId);
    formData.append('forExport', true)
    formData.append('exportCsv', true)
    const url = props.ctx.showShapeData?.current ? "file-handler/getStandGeojson" : "api/get_flight_geojson"
    // console.log(url)
    var config = {
      method: 'post',
      url: url,
      data: props.ctx.showShapeData?.current ? formData : {'token': token, 'id': props.itemToDownload._id}
  };
  
    axios(config)
     .then((res) => {
      if(props.ctx.showShapeData?.current && res && !hasAccess(customer, Access.DOWNLOAD_GEOREFERENCED_DATA.number)){
        const taskId = res?.data?.task_id;
        const resStatus = res?.data?.status ? res.data?.status : 'Fetching data';
        setStatus(resStatus)
        if(taskId){
          pollStatus(taskId)
        }
      } else {
        if(res.data?.geojson){
          // const json = JSON.stringify(res.data.trajectory, null, 2);
          const geojson = res.data.geojson;
          const csvContent = geojsonToCSV(geojson);

          const blob = new Blob([csvContent], { type: "text/csv" });
          // const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

       
          // const blob = new Blob([res.data.geojson], { type: "application/json" });
          // // console.log(blob)

          setHref(URL.createObjectURL(blob))
          // // console.log("setting download ok")
          setOkToDownload(true)
          setLoading(false)
        } else {
          setHref(null)        
          // // console.log("setting download false")
          // setLoading(false)
          setOkToDownload(false)
        }
      }
    })
    .catch((err) => {
      console.error("Failed to start scramble:", err);
      setStatus('Falied to fetch data')
      setOkToDownload(false);
      setLoading(false)

      setHref(null);
    });
  };
  const fetchStatus = async (taskId) => {
    const formData = new FormData();
    formData.append("token", token);

    const res = await axios.post(`file-handler/status/${taskId}`, formData);
    return res.data;
  };
  const pollStatus = (taskId) => {
    const interval = setInterval(async () => {
      try {
        const res = await fetchStatus(taskId)

        if (res?.status === "complete") {
          clearInterval(interval);
          fetchResult(taskId);
          setStatus('Fetching data')
        } else if (res?.status === "failed") {
          clearInterval(interval);
          setStatus('Failed to get data')
          setOkToDownload(false);
          setLoading(true)

          setHref(null);
        } else if (res?.status !== status) {
          setStatus(res?.status)
        }
      } catch (err) {
        clearInterval(interval);
        setOkToDownload(false);
        setLoading(false)
        setStatus('Failed to get data')

        setHref(null);
      }
    }, 3000);
  };
  const fetchResult = async (taskId) => {
    try {
      const formData = new FormData();
      formData.append("token", token);

      const res = await axios.post(`file-handler/result/${taskId}`, formData);
      const geojson = res.data;
      const csvContent = geojsonToCSV(geojson);

      const blob = new Blob([csvContent], { type: "text/csv" });

      setHref(URL.createObjectURL(blob));
      setOkToDownload(true);
      setLoading(false)

    } catch (err) {
      setStatus("Failed to get data")
      setOkToDownload(false);
      setLoading(false)

      setHref(null);
    }
  };
  const name = okToDownload && props.itemToDownload ? props.ctx?.showShapeData?.current &&  props.ctx.selectedTimeFrame? props.itemToDownload.alias+"-"+props.ctx.selectedTimeFrame : props.itemToDownload.alias : ""

  let title = okToDownload ? "Download csv data of stand" + props.itemToDownload ? props.ctx?.showShapeData?.current ?  props.itemToDownload?.alias +'-'+ props.ctx.selectedTimeFrame : props.itemToDownload?.alias : "CSV does not exist for this stand" : '' 
  useEffect(()=>{
    // console.log(props.downloadCSVDialogShow)
    // console.log(props.itemToDownload)
    if(props.downloadCSVDialogShow && props.itemToDownload){
        setStatus('Starting to fetch data')
        setLoading(true)

        tryRequire()
    }
  }, [props.downloadCSVDialogShow])
  return (
    <Modal
      show={props.downloadCSVDialogShow}
      onHide={() => {
        setOkToDownload(false)
        props.setDownloadCSVDialogShow(false)}}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    > 
      <div style={{backgroundColor: "#212529", color: "#ffffff"}}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {!okToDownload && (<><p>{status}</p> {loading &&<LoadingSpinner/>}</>)}
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button onClick={() => {
          setOkToDownload(false)
          props.setDownloadCSVDialogShow(false)}}>Cancel</Button>
          <Button
          disabled={!okToDownload} 
          href={href} 
          download={hasAccess(customer, Access.DOWNLOAD_GEOREFERENCED_DATA.number) ? name+'.csv' : name+'_scrambled_data.csv'} 
          onClick={() => { 
            props.setDownloadCSVDialogShow(false)}}>
              Download
          </Button>
      </Modal.Footer>
      </div>
    </Modal>
  );
}

 
DownloadCSVPopup.propTypes = {
  ctx: PropTypes.object.isRequired,
  itemToDownload: PropTypes.object.isRequired,
  downloadCSVDialogShow: PropTypes.object.isRequired,
  setDownloadCSVDialogShow: PropTypes.func.isRequired,
  data: PropTypes.string.isRequired,
}